import mutations from './mutations';

const getters = {
  underlyingFunds: state => state
};

const state = {
  Data: null,
  Frequency: null,
  base64ChartImage: null,
  AsOfDate: null
};


export default {
  state,
  mutations,
  getters
};
